module.exports = __webpack_public_path__ + "img/iosStep-3.041508bc.webp";